export default __webpack_public_path__ + "static/media/project_thumbnail_drillingchicks.54e2852d.png";